<!-- 商户资料提交 -->

<template>
    <div class="merInf">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <!-- <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                       <div class="left flex flex-align-center search">
                        </div>
                        <div class="right addBtn">
                            <button type="button" @click="dialogVisible=true"><i class="el-icon-plus"></i>添加员工</button>
                        </div>
                    </div>
                </div> -->
                <div class="HSpace1"></div>

                <div class="merMsg1">
                    <form>
                        <div class="part">
                            <div class="title flex flex-align-center">负责人信息（必填）</div>
                            <div class="partCon clearfix">
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">法人</div>
                                    <input class="msgInput left" type="text" placeholder="请输入法人姓名" v-model="contact.name">
                                </div>
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">身份证号码</div>
                                    <input class="msgInput left" type="text" placeholder="请输入经营者身份证号码" v-model="contact.nicNumber">
                                </div>
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">联系电话</div>
                                    <input class="msgInput left" type="text" placeholder="请输入经营者手机号" v-model="contact.mobile">
                                </div>
                                 <!--<div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">微信号</div>
                                    <input class="msgInput left" type="text" placeholder="请输入经营者微信号" v-model="contact.wechatId">
                                </div>
                                <div class="msgItem left clearfix">
                                    <div class="tipName left flex flex-align-center">（微信要求已绑定银行卡完成实名认证，且实名的姓名与所填写的联系人姓名一致）</div>
                                </div> -->
                            </div>
                        </div>
                        <div class="part">
                            <div class="title flex flex-align-center">商户资料（必填）</div>
                            <div class="partCon clearfix">
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">商户名称</div>
                                    <input class="msgInput left" type="text" placeholder="需与营业执照名称一致" v-model="info.name">
                                </div>
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">商户简称</div>
                                    <input class="msgInput left" type="text" placeholder="用于在付款页面向客户展示" v-model="info.abbrName">
                                </div>
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">统一社会信用代码</div>
                                    <input class="msgInput left" type="text" placeholder="统一社会信用代码" v-model="info.licenseNumber">
                                </div>
                                <!-- <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">行业类别</div>
                                    <input class="msgInput left" type="text" placeholder="按营业执照选择行业">
                                </div> -->
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">省市区</div>
                                    <input class="msgInput left" type="text" placeholder="请选择商户所在省市" @click="showSelectAdd=true;isBankArea=false;" readonly="" style="cursor:pointer" v-model="info.adName">
                                </div>
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">详细地址</div>
                                    <input class="msgInput left" type="text" placeholder="如：XX区XX街道XX号" v-model="info.addr">
                                </div>
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">联系邮箱</div>
                                    <input class="msgInput left" type="text" placeholder="接受重要信息" v-model="info.email">
                                </div>
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">客服电话</div>
                                    <input class="msgInput left" type="text" placeholder="可填写手机号、座机号码" v-model="info.customerServiceTele">
                                </div>
                            </div>
                        </div>

                        <div class="part">
                            <div class="title flex flex-align-center">添加结算银行卡信息（必填,以下信息务必填写正确,如有错误,将无法结算!）</div>
                            <div class="partCon clearfix">
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">开户人</div>
                                    <input class="msgInput left" type="text" placeholder="请输入开户人姓名" v-model="card.accountHolder">
                                </div>
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">开户身份证</div>
                                    <input class="msgInput left" type="text" placeholder="请输入开户人身份证号" v-model="card.nicNumber">
                                </div>
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">预留手机号</div>
                                    <input class="msgInput left" type="text" placeholder="请输入开户银行预留手机号" v-model="card.mobile">
                                </div>
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">银行卡号</div>
                                    <input class="msgInput left" type="text" placeholder="请输入银行卡号" v-model="card.debitCardNumber">
                                </div>
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">开户银行</div>
                                    <input class="msgInput left" type="text" placeholder="请输入开户银行" v-model="card.bankName">
                                </div>
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">开户省市</div>
                                    <input class="msgInput left" type="text" placeholder="请选择开户省市" @click="showSelectAdd=true;isBankArea=true;" readonly="" style="cursor:pointer" v-model="card.adName">
                                </div>
                                <div class="msgItem left clearfix">
                                    <div class="name left flex flex-align-center">开户支行</div>
                                    <input class="msgInput left" type="text" placeholder="请选择开户支行名称" v-model="card.branchBankName">
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="merMsg2">
                	<form>
                		<div class="part2">
                			<div class="title flex flex-align-center">商户图片资料（必填）</div>
                			<div class="fileBox clearfix">
	                			<div class="upFile left">
	                				<div class="name flex flex-pack-center flex-align-center">上传营业执照</div>
	                				<div class="flex comFile flex-align-center flex-pack-center">
		                				<i class="el-icon-plus avatar-uploader-icon"></i>
		                				<div class="img">
		                					<img v-if="businessLicenseImage" :src="businessLicenseImage" alt="">
		                				</div>
		                				<input type="file" class="fileInput pcImgFile" accept=".png,.jpg,.jpeg" @change="coverImg($event,'businessLicenseImage')" title="选择营业执照">
                                        <input type="file" accept="image/*" @change="coverImg($event,'businessLicenseImage')" class="fileInput mobileImg">
	                				</div>
	                			</div><div class="upFile left">
	                				<div class="name flex flex-pack-center flex-align-center">上传法人身份证人像面</div>
	                				<div class="flex comFile flex-align-center flex-pack-center">
		                				<i class="el-icon-plus avatar-uploader-icon"></i>
		                				<div class="img">
		                					<img v-if="nicCardUpSideImage" :src="nicCardUpSideImage" alt="">
		                				</div>
		                				<input type="file" class="fileInput pcImgFile" accept=".png,.jpg,.jpeg" @change="coverImg($event,'nicCardUpSideImage')" title="选择身份证人像面">
                                        <input type="file" accept="image/*" @change="coverImg($event,'nicCardUpSideImage')" class="fileInput mobileImg">
	                				</div>
	                			</div><div class="upFile left">
	                				<div class="name flex flex-pack-center flex-align-center">上传法人身份证国徽面</div>
	                				<div class="flex comFile flex-align-center flex-pack-center">
		                				<i class="el-icon-plus avatar-uploader-icon"></i>
		                				<div class="img">
		                					<img v-if="nicCardDownSideImage" :src="nicCardDownSideImage" alt="">
		                				</div>
		                				<input type="file" class="fileInput pcImgFile" accept=".png,.jpg,.jpeg" @change="coverImg($event,'nicCardDownSideImage')" title="选择身份证国徽面">
                                        <input type="file" accept="image/*" @change="coverImg($event,'nicCardDownSideImage')" class="fileInput mobileImg">
	                				</div>
	                			</div>
                                <!-- new add 4.29 -->
                                <div class="upFile left">
	                				<div class="name flex flex-pack-center flex-align-center">上传银行卡结算人身份证人像面</div>
	                				<div class="flex comFile flex-align-center flex-pack-center">
		                				<i class="el-icon-plus avatar-uploader-icon"></i>
		                				<div class="img">
		                					<img v-if="nicCardUpSideImageForConcat" :src="nicCardUpSideImageForConcat" alt="">
		                				</div>
		                				<input type="file" class="fileInput pcImgFile" accept=".png,.jpg,.jpeg" @change="coverImg($event,'nicCardUpSideImageForConcat')" title="选择身份证国徽面">
                                        <input type="file" accept="image/*" @change="coverImg($event,'nicCardUpSideImageForConcat')" class="fileInput mobileImg">
	                				</div>
	                			</div>
                                <div class="upFile left">
	                				<div class="name flex flex-pack-center flex-align-center">上传银行卡结算人身份证国徽面</div>
	                				<div class="flex comFile flex-align-center flex-pack-center">
		                				<i class="el-icon-plus avatar-uploader-icon"></i>
		                				<div class="img">
		                					<img v-if="nicCardDownSideImageForConcat" :src="nicCardDownSideImageForConcat" alt="">
		                				</div>
		                				<input type="file" class="fileInput pcImgFile" accept=".png,.jpg,.jpeg" @change="coverImg($event,'nicCardDownSideImageForConcat')" title="选择身份证国徽面">
                                        <input type="file" accept="image/*" @change="coverImg($event,'nicCardDownSideImageForConcat')" class="fileInput mobileImg">
	                				</div>
	                			</div>
                                <!-- new add end -->
                                <div class="upFile left">
	                				<div class="name flex flex-pack-center flex-align-center">上传门头照</div>
	                				<div class="flex comFile flex-align-center flex-pack-center">
		                				<i class="el-icon-plus avatar-uploader-icon"></i>
		                				<div class="img">
		                					<img v-if="storeImage" :src="storeImage" alt="">
		                				</div>
		                				<input type="file" class="fileInput pcImgFile" accept=".png,.jpg,.jpeg" @change="coverImg($event,'storeImage')" title="选择门头照" id="image">
                                        <input type="file" accept="image/*" @change="coverImg($event,'storeImage')" class="fileInput mobileImg">
	                				</div>
	                			</div>
                                <div class="upFile left">
	                				<div class="name flex flex-pack-center flex-align-center">上传银行卡正面照</div>
	                				<div class="flex comFile flex-align-center flex-pack-center">
		                				<i class="el-icon-plus avatar-uploader-icon"></i>
		                				<div class="img">
		                					<img v-if="bankCardImage" :src="bankCardImage" alt="">
		                				</div>
		                				<input type="file" class="fileInput pcImgFile" accept=".png,.jpg,.jpeg" @change="coverImg($event,'bankCardImage')" title="" id="image">
                                        <input type="file" accept="image/*" @change="coverImg($event,'bankCardImage')" class="fileInput mobileImg">
	                				</div>
	                			</div>
                                <!-- new add 4.29 -->
                                <div class="upFile left">
	                				<div class="name flex flex-pack-center flex-align-center">上传银行卡背面照</div>
	                				<div class="flex comFile flex-align-center flex-pack-center">
		                				<i class="el-icon-plus avatar-uploader-icon"></i>
		                				<div class="img">
		                					<img v-if="bankCardDowmImage" :src="bankCardDowmImage" alt="">
		                				</div>
		                				<input type="file" class="fileInput pcImgFile" accept=".png,.jpg,.jpeg" @change="coverImg($event,'bankCardDowmImage')" title="" id="image">
                                        <input type="file" accept="image/*" @change="coverImg($event,'bankCardDowmImage')" class="fileInput mobileImg">
	                				</div>
	                			</div>
                                <!-- new add end -->
                                <div class="upFile left">
	                				<div class="name flex flex-pack-center flex-align-center">上传吧台照片</div>
	                				<div class="flex comFile flex-align-center flex-pack-center">
		                				<i class="el-icon-plus avatar-uploader-icon"></i>
		                				<div class="img">
		                					<img v-if="barImage" :src="barImage" alt="">
		                				</div>
		                				<input type="file" class="fileInput pcImgFile" accept=".png,.jpg,.jpeg" @change="coverImg($event,'barImage')" title="" id="image">
                                        <input type="file" accept="image/*" @change="coverImg($event,'barImage')" class="fileInput mobileImg">
	                				</div>
	                			</div>
                                <div class="upFile left">
	                				<div class="name flex flex-pack-center flex-align-center">上传内景照片</div>
	                				<div class="flex comFile flex-align-center flex-pack-center">
		                				<i class="el-icon-plus avatar-uploader-icon"></i>
		                				<div class="img">
		                					<img v-if="innerImage" :src="innerImage" alt="">
		                				</div>
		                				<input type="file" class="fileInput pcImgFile" accept=".png,.jpg,.jpeg" @change="coverImg($event,'innerImage')" title="" id="image">
                                        <input type="file" accept="image/*" @change="coverImg($event,'innerImage')" class="fileInput mobileImg">
	                				</div>
	                			</div>
                                <!-- 2020.5.13 -->
                                <div class="upFile left">
	                				<div class="name flex flex-pack-center flex-align-center">其他资料照片1(非必填)</div>
	                				<div class="flex comFile flex-align-center flex-pack-center">
		                				<i class="el-icon-plus avatar-uploader-icon"></i>
		                				<div class="img">
		                					<img v-if="otherImageOne" :src="otherImageOne" alt="">
		                				</div>
		                				<input type="file" class="fileInput pcImgFile" accept=".png,.jpg,.jpeg" @change="coverImg($event,'otherImageOne')" title="" id="image">
                                        <input type="file" accept="image/*" @change="coverImg($event,'otherImageOne')" class="fileInput mobileImg">
	                				</div>
	                			</div>
                                <div class="upFile left">
	                				<div class="name flex flex-pack-center flex-align-center">其他资料照片2(非必填)</div>
	                				<div class="flex comFile flex-align-center flex-pack-center">
		                				<i class="el-icon-plus avatar-uploader-icon"></i>
		                				<div class="img">
		                					<img v-if="otherImageTwo" :src="otherImageTwo" alt="">
		                				</div>
		                				<input type="file" class="fileInput pcImgFile" accept=".png,.jpg,.jpeg" @change="coverImg($event,'otherImageTwo')" title="" id="image">
                                        <input type="file" accept="image/*" @change="coverImg($event,'otherImageTwo')" class="fileInput mobileImg">
	                				</div>
	                			</div>
                                <!-- 2020.5.13end -->
                                <!--  -->
                			</div>
                		</div>
                	</form>
                </div>
                <div class="nextBtn flex flex-align-center">
                    <button class="upLoad" @click="upLoad">确定上传</button>
                </div>
                
                <el-dialog
                    title="地址选择"
                    :visible.sync="showSelectAdd"
                    size="tiny">
                    <div class="selectAddBox clearfix">
                        <ul class="item province left">
                            <li v-for="(item,idx) in provinceList" :class="{active:(curProvinceIdx==idx)}" @click="selectProvince(item,idx)" v-text="item.name"></li>
                        </ul>
                        <ul class="item city left">
                            <li v-for="(item,idx) in cityList" :class="{active:(curCityIdx==idx)}" @click="selectCity(item,idx)" v-text="item.name"></li>
                        </ul>
                        <ul class="item country left">
                            <li v-for="(item,idx) in countryList" :class="{active:(curCountryIdx==idx)}" @click="selectCountry(item, idx)" v-text="item.name"></li>
                        </ul>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <button type="button" @click="showSelectAdd=false" class="cancel">取消</button>
                        <button type="button" @click="saveAdd()" class="save">保存</button>
                    </span>
                </el-dialog>
                
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import {API_BASE_URL} from "./../../../urlConfig/index";
    export default{
        props: ['curStoreId','storeData'],
    	data () {
    		return {
                innerImage:"",//内景照片
                barImage:"",//吧台照片
                bankCardImage:"",//银行卡照片
                curMerId: '',//提交资料id
                coverImgMaxSize: 5*1024*1024, // 图片最大字节数
                contact:{
                	"name": "",
				    "nicNumber": "",
				    "mobile": "",
				    "wechatId": ""
                },
                info: {
				    "name": "",
				    "abbrName": "",
				    "licenseNumber": "",
				    "adName": "",
				    "addr": "",
				    "email": "",
				    "customerServiceTele": ""
				},
				card: {
				    "accountHolder": "",
				    "nicNumber": "",
				    "mobile": "",
				    "debitCardNumber": "",
				    "bankName": "",
				    "adName": "",
				    "branchBankName": ""
				},
				businessLicenseImage:'',//营业执照
				nicCardUpSideImage:'',//身份证人像面
                nicCardDownSideImage:'',//身份证反面
                nicCardUpSideImageForConcat:"",//联系人身份证正面
                nicCardDownSideImageForConcat:"",//联系人身份证反面
                bankCardDowmImage:"",//银行卡背面
                otherImageOne:"",//其他资料1
                otherImageTwo:"",//其他资料2
				storeImage:'',//传门头照
                willSendData:{},


                showSelectAdd: false, // 显示地址选择框

                provinceList: [],
                cityList: [],
                countryList: [],

                curProvinceIdx: null,
                curCityIdx: null,
                curCountryIdx: null,

                isBankArea: false
    		}
    	},
        methods: {
            regFn(){
                if(!this.contact.name){
                    this.$message({
                        message: '请输入联系人姓名',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.contact.nicNumber){
                    this.$message({
                        message: '请输入身份证号码',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.contact.mobile){
                    this.$message({
                        message: '经营者手机号格式不对',
                        customClass: 'error'
                    });
                    return true;
                }
                // if(!this.contact.wechatId){
                //     this.$message({
                //         message: '经营者微信号格式不对',
                //         customClass: 'error'
                //     });
                //     return true;
                // }
                // if(!this.contact.wechatId){
                //     this.$message({
                //         message: '经营者微信号格式不对',
                //         customClass: 'error'
                //     });
                //     return true;
                // }
                if(!this.info.name){
                    this.$message({
                        message: '商户名称格式不对',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.info.abbrName){
                    this.$message({
                        message: '商户简称格式不对',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.info.licenseNumber){
                    this.$message({
                        message: '营业执照注册号格式不对',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.info.adName){
                    this.$message({
                        message: '请选择商户省市区',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.info.addr){
                    this.$message({
                        message: '商户详细地址格式不对',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.info.email){
                    this.$message({
                        message: '联系邮箱格式不对',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.info.customerServiceTele){
                    this.$message({
                        message: '客服电话格式不对',
                        customClass: 'error'
                    });
                    return true;
                }

                if(!this.card.accountHolder){
                    this.$message({
                        message: '开户人格式不对',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.card.nicNumber){
                    this.$message({
                        message: '开户身份证格式不对',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.card.mobile){
                    this.$message({
                        message: '预留手机号格式不对',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.card.debitCardNumber){
                    this.$message({
                        message: '银行卡号格式不对',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.card.bankName){
                    this.$message({
                        message: '开户银行格式不对',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.card.adName){
                    this.$message({
                        message: '请选择开户省市',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.card.branchBankName){
                    this.$message({
                        message: '开户支行格式不对',
                        customClass: 'error'
                    });
                    return true;
                }

                if(!this.businessLicenseImage){
                    this.$message({
                        message: '请上传营业执照',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.nicCardUpSideImage){
                    this.$message({
                        message: '请上传法人身份证人像面',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.nicCardDownSideImage){
                    this.$message({
                        message: '请上传法人身份证国徽面',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.storeImage){
                    this.$message({
                        message: '请上传门头照',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.innerImage){
                    this.$message({
                        message: '请上传内景照片',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.barImage){
                    this.$message({
                        message: '请上传吧台照片',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.bankCardImage){
                    this.$message({
                        message: '请上传银行卡照片',
                        customClass: 'error'
                    });
                    return true;
                }
            },
        	//商户信息
        	merInfo(){
        		this.curMerId=this.curMerId?this.curMerId:this.$uuid.create(1).hex;
        		let body = {
				  "storeId": this.curStoreId,
				  "businessLicenseImage": this.businessLicenseImage,
				  "nicCardUpSideImage": this.nicCardUpSideImage,
				  "nicCardDownSideImage": this.nicCardDownSideImage,
				  "storeImage": this.storeImage,
				  "contact": this.contact,
				  "info": this.info,
                  "card": this.card,
                  "bankCard":this.bankCardImage,
                  "innerCard":this.innerImage,
                  "barCard":this.barImage,
                  "bankCardSide":this.bankCardDowmImage,//跟后端字段名有点出入,这里是银行卡背面信息，非必填
                  "oneManagePlace":this.nicCardUpSideImageForConcat,//联系人身份证正面信息,非必填
                  "twoManagePlace":this.nicCardDownSideImageForConcat,//联系人身份证反面信息,非必填
                  "otherImageOne":this.otherImageOne,//其他资料,非必填
                  "otherImageTwo":this.otherImageTwo,//其他资料,非必填
				};
				console.log(this.curMerId)
        		this.$http.put('/profile',body).then((res)=>{
        			this.$message({
                        message: '操作成功！',
                        customClass: 'success'
                    });
        			this.getMerInfo();
        		})
        	},
        	//获取商户资料
        	getMerInfo(){
        		this.$http.get('profile?storeId='+this.curStoreId).then((res)=>{
        			this.contact = res.data.contact;
        			this.info = res.data.info;
        			this.card = res.data.card;
        			this.curMerId = res.data.id;
        			this.businessLicenseImage = res.data.businessLicenseImage;
        			this.nicCardUpSideImage = res.data.nicCardUpSideImage;
        			this.nicCardDownSideImage = res.data.nicCardDownSideImage;
                    this.storeImage = res.data.storeImage;
                    this.bankCardImage = res.data.bankCard;
                    this.innerImage = res.data.innerCard;
                    this.barImage = res.data.barCard;
                    // 
                    this.bankCardDowmImage = res.data.bankCardSide;
                    this.nicCardUpSideImageForConcat = res.data.oneManagePlace;
                    this.nicCardDownSideImageForConcat = res.data.twoManagePlace;
                    this.otherImageOne = res.data.otherImageOne;
                    this.otherImageTwo = res.data.otherImageTwo;
        		}).catch((err)=>{
        		})
        	},
        	//确定上传资料
        	upLoad () {
                if(this.regFn()){
                    return;
                };
        		this.$confirm('确认提交数据, 是否继续?', '提示', {
                	confirmButtonText: '确定',
                  	cancelButtonText: '取消',
                  	type: 'warning'
                }).then(() => {
                    this.merInfo();
                }).catch(() => {});
        	},
        	//上传照片
        	coverImg: function ( e, ind ) {
        		//ind为区分四张图片
                let reader = new FileReader();
                let that = this;
                let fileObj = e.target.files[0];

                if( e.target.files.length == 0 ) {
                    return false;
                }
                // 判断图片大小
                if( fileObj.size > this.coverImgMaxSize ) {
                    this.errorMsg = '上传图片的大小不能超过5MB';
                    this.openErrorTip = true;
                    this.$message({
                        message: '上传图片的大小不能超过5MB',
                        customClass: 'error'
                    })
                    return false;
                }
                reader.onload = (function (file) {
                    return function (e) {
                //         innerImage:"",//内景照片
                // barImage:"",//吧台照片
                // bankCardImage:"",//银行卡照片
                        that.$http.post(API_BASE_URL+'v1/image/json/upload?storeId='+this.curStoreId, {file: this.result}).then((res)=>{
                        	if(ind=='businessLicenseImage'){
                            	that.businessLicenseImage = res.data.path; //获得图片的base64的数据
                        	}else if(ind=='nicCardUpSideImage'){
                        		that.nicCardUpSideImage = res.data.path; //获得图片的base64的数据
                        	}else if(ind=='nicCardDownSideImage'){
                        		that.nicCardDownSideImage = res.data.path; //获得图片的base64的数据
                        	}else if(ind=='storeImage'){
                        		that.storeImage = res.data.path; //获得图片的base64的数据
                        	}else if(ind=='innerImage'){
                        		that.innerImage = res.data.path; //获得图片的base64的数据
                        	}else if(ind=='barImage'){
                        		that.barImage = res.data.path; //获得图片的base64的数据
                        	}else if(ind=='bankCardImage'){
                        		that.bankCardImage = res.data.path; //获得图片的base64的数据
                        	}else if(ind=='bankCardDowmImage'){
                        		that.bankCardDowmImage = res.data.path; //获得图片的base64的数据
                        	}else if(ind=='nicCardUpSideImageForConcat'){
                        		that.nicCardUpSideImageForConcat = res.data.path; //获得图片的base64的数据
                        	}else if(ind=='nicCardDownSideImageForConcat'){
                        		that.nicCardDownSideImageForConcat = res.data.path; //获得图片的base64的数据
                            }else if(ind=='otherImageOne'){
                        		that.otherImageOne = res.data.path; //获得图片的base64的数据
                        	}else if(ind=='otherImageTwo'){
                        		that.otherImageTwo = res.data.path; //获得图片的base64的数据
                        	}
	                    }).catch(()=>{
	                    });
                    };
                })(e.target.files[0]);
                reader.readAsDataURL(e.target.files[0]);
            },

            // 选择省
            selectProvince: function ( item, idx ) {
                this.curProvinceIdx = idx;
                this.curCityIdx = null;
                this.curCountryIdx = null;
                this.cityList = [];
                this.countryList = [];

                let _this = this;
                $.get("https://restapi.amap.com/v3/config/district?key=ffb08209d403b98295cff1f4309f0652&subdistrict=1&extensions=base&keywords="+item.adcode, function(result){
                    _this.cityList = result.districts[0].districts;
                });
            },

            // 选择市
            selectCity: function ( item, idx ) {
                this.curCityIdx = idx;
                this.curCountryIdx = null;
                this.countryList = [];

                let _this = this;
                $.get("https://restapi.amap.com/v3/config/district?key=ffb08209d403b98295cff1f4309f0652&subdistrict=1&extensions=base&keywords="+item.adcode, function(result){
                    _this.countryList = result.districts[0].districts;
                });
            },

            // 选择区
            selectCountry: function ( item, idx ) {
                this.curCountryIdx = idx;
            }, 

            // 确认选择地区 
            saveAdd: function () {
                if ( !(this.curProvinceIdx >= 0 && this.curCityIdx >= 0  && this.curCountryIdx >= 0) ) {
                    this.$message({
                        message: '请选择地区',
                        customClass: 'error'
                    });
                    return;
                }

                if ( this.isBankArea ) {
                    this.card.adName = this.provinceList[this.curProvinceIdx].name + " " + this.cityList[this.curCityIdx].name + " " + this.countryList[this.curCountryIdx].name;
                } else {
                    this.info.adName = this.provinceList[this.curProvinceIdx].name + " " + this.cityList[this.curCityIdx].name + " " + this.countryList[this.curCountryIdx].name;
                }

                this.showSelectAdd = false;
                this.curProvinceIdx = null;
                this.curCityIdx = null;
                this.curCountryIdx = null;
                this.cityList = [];
                this.countryList = [];
            }

        },
        created: function () {
        	this.getMerInfo();
            let _this = this;
            $.get("https://restapi.amap.com/v3/config/district?key=ffb08209d403b98295cff1f4309f0652&subdistrict=1&extensions=base", function(result){
                _this.provinceList = result.districts[0].districts;

            });
        },
        mounted: function () {
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/el-dialog.scss';
	@import "merCert.scss";
	
</style>



// WEBPACK FOOTER //
// merCert.vue?3e84741a